import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Panel
} from 'react-bootstrap';
import { SwitchButton } from 'components/switch-button';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Textarea from '../../components/react-validation/components/text-area';
import * as Vali from '../../helper/validator-helper';
import NumberInput from 'components/number-input';
import Translate from 'components/translate';

class SettingWorkOrderEmail extends Component {
  static propTypes = {
    onSaveNotice: PropTypes.func,
    noticeRequest: PropTypes.object,
    projectOperation: PropTypes.object,
    onSaveProjectOperation: PropTypes.func,
    isNotAllowedEdit: PropTypes.bool
  }

  constructor(props) {
    super(props);
    this.state = {
      firstNotice: null,
      secondNotice: null,
      thirdNotice: null,
      closeRequest: null,
      switch: null,
      expandSetting: false,
      overdue: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.projectOperation &&
      nextProps.noticeRequest &&
      nextProps.noticeRequest.notices &&
      nextProps.noticeRequest.closeRequestSinceLastNoticeSent) {
      const firstNotice = nextProps.noticeRequest.notices.filter(element => {
        return element.order === 1;
      });
      const secondNotice = nextProps.noticeRequest.notices.filter(element => {
        return element.order === 2;
      });
      const thirdNotice = nextProps.noticeRequest.notices.filter(element => {
        return element.order === 3;
      });
      this.setState({
        overdue: nextProps.projectOperation.workOrderDueIn,
        firstNotice: firstNotice[0],
        secondNotice: secondNotice[0],
        thirdNotice: thirdNotice[0],
        closeRequest: nextProps.noticeRequest.closeRequestSinceLastNoticeSent
      });
    }

    if (nextProps.projectOperation) {
      this.setState({
        switch: nextProps.projectOperation.sendWONotification
      });
    }

    if (nextProps.isNotAllowedEdit) {
      this.setState({expandSetting: false});
    }
  }

  onSaveProjectOperation = () => {
    this.props.onSaveProjectOperation(this.state.switch);
  }

  onChangeSwitch = () => {
    this.setState({
      switch: !this.state.switch
    }, () => {
      this.setState({ expandSetting: this.state.switch });
      this.onSaveProjectOperation();
    });
  }

  handleTitleClick = () => {
    if (this.state.switch && !this.props.isNotAllowedEdit) {
      this.setState({
        expandSetting: !this.state.expandSetting
      });
    }
  }

  handleChangeOverdue = (e) => {
    const overdue = e.target.value;
    if (overdue <= 100) {
      if (overdue >= 1) {this.setState({overdue: e.target.value});}
      else {this.setState({overdue: 1});}
    }
  }

  renderCaretIcon = () => {
    if (!this.props.isNotAllowedEdit && this.state.switch) {
      if (this.state.expandSetting) {
        return <span><i className='pe-7s-angle-down expand-ic' /></span>;
      } else {
        return <span><i className='pe-7s-angle-right expand-ic' /></span>;
      }
    } else {
      return null;
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const params = this.form.getValues();
    params['secondNumOfDay'] = this.secondNumOfDay.state.value;
    params['thirdNumOfDay'] = this.thirdNumOfDay.state.value;
    params['closeNumOfDay'] = this.closeNumOfDay.state.value;
    this.props.onSaveNotice(params);
  }

  render() {
    const { firstNotice, secondNotice, thirdNotice, closeRequest } = this.state;
    return (
      <Panel expanded={this.state.expandSetting} className={this.props.isNotAllowedEdit ? 'panel-disabled' : ''} onToggle={() => {}}>
        <Panel.Heading>
          <Panel.Title
            onClick={this.handleTitleClick}
            style={this.state.switch ? {cursor: 'pointer'} : {}} >
                Auto-send emails to request creators/<Translate translateKey='homeowner' /> upon resolution of all work orders under a request
            {this.renderCaretIcon()}
          </Panel.Title>
          <SwitchButton
            className='pull-right'
            ref={c => { this.switch = c; }}
            name='switch'
            disabled={this.props.isNotAllowedEdit}
            style={{display: 'inline-block'}}
            checked={this.state.switch}
            onCheck={this.onChangeSwitch} />
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
              <div className='row'>
                <div className='col-sm-5 col-sm-offset-2'>
                  <span>Message</span>
                </div>
              </div>
              <div className='row' style={{marginTop: 5}}>
                <div className='col-sm-2'>
                  <label style={{fontWeight: 'normal'}}>First notice <span className='text-danger'>*</span></label>
                </div>
                <div className='col-sm-5'>
                  <Textarea
                    style={{height: 120}}
                    name='first'
                    ref='first'
                    value={firstNotice ? firstNotice.content : '<Notice content here>'}
                    className='form-control'
                    max='500'
                    maxLength='500'
                    errorMsg='First notice is maximum 500 characters'
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
                <div className='col-sm-3'>
                    sent right after there is no open work orders left under a request.
                </div>
              </div>
              <div className='row' style={{marginTop: 25}}>
                <div className='col-sm-3 col-sm-offset-7'>
                    # of days after the previous notice
                </div>
              </div>
              <div className='row' style={{marginTop: 15}}>
                <div className='col-sm-2'>
                  <label style={{fontWeight: 'normal'}}>Second notice <span className='text-danger'>*</span></label>
                </div>
                <div className='col-sm-5'>
                  <Textarea
                    style={{height: 120}}
                    name='second'
                    ref='second'
                    value={secondNotice ? secondNotice.content : '<Notice content here>'}
                    className='form-control'
                    max='500'
                    maxLength='500'
                    errorMsg='Second notice is maximum 500 characters'
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
                <div className='col-sm-3'>
                  <NumberInput
                    ref={c => { this.secondNumOfDay = c; }}
                    value={secondNotice ? secondNotice.sendAfter : 2}
                    min={1}
                    max={100} />
                </div>
              </div>
              <div className='row' style={{marginTop: 15}}>
                <div className='col-sm-2'>
                  <label style={{fontWeight: 'normal'}}>Third notice <span className='text-danger'>*</span></label>
                </div>
                <div className='col-sm-5'>
                  <Textarea
                    style={{height: 120}}
                    name='third'
                    ref='third'
                    value={thirdNotice ? thirdNotice.content : '<Notice content here>'}
                    className='form-control'
                    max='500'
                    maxLength='500'
                    errorMsg='Third notice is maximum 500 characters'
                    validations={[Vali.required, Vali.maxlength]} />
                </div>
                <div className='col-sm-3'>
                  <NumberInput
                    ref={c => { this.thirdNumOfDay = c; }}
                    value={thirdNotice ? thirdNotice.sendAfter : 2}
                    min={1}
                    max={100} />
                </div>
              </div>
              <div className='row' style={{ marginTop: 15, marginBottom: 15}}>
                <div className='col-sm-10'>
                  <div>Close the request automatically after
                    <NumberInput
                      ref={c => { this.closeNumOfDay = c; }}
                      value={closeRequest ? closeRequest : 2}
                      min={1}
                      max={100}
                      style={{display: 'inline-block', margin: '0 5px'}} />
                    days since the last notice is sent out.
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-10'>
                  <Submit className='btn btn-primary btn-siteone'>Save</Submit>
                </div>
              </div>
            </Form>
            <div className={this.props.isNotAllowedEdit ? 'faded-layer' : null} />
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default SettingWorkOrderEmail;




// WEBPACK FOOTER //
// ./src/Setting/Components/setting-work-order-email.js